import React, { useLayoutEffect, useMemo, useState } from "react";
import { useLocation, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const location = useLocation();
  const [processing, setProcessing] = useState(true);

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const tokenInUrl = searchParams.get("token");
  const clientInUrl = searchParams.get("clientId");

  useLayoutEffect(() => {
    const tokenFromUrl = tokenInUrl?.trim();
    const clientFromUrl = clientInUrl?.trim();

    let touched = false;

    if (tokenFromUrl) {
      localStorage.setItem("token", tokenFromUrl);
      touched = true;
    }

    if (clientFromUrl) {
      localStorage.setItem("clientId", clientFromUrl);
      touched = true;
    }

    if (touched) {
      const cleanUrl = location.pathname + location.hash;
      window.history.replaceState({}, "", cleanUrl);
    }

    setProcessing(false);
  }, [tokenInUrl, clientInUrl, location.pathname, location.hash]);

  if (processing) return null;

  const finalToken = localStorage.getItem("token");
  const finalClientId = localStorage.getItem("clientId");

  if (!finalToken || !finalClientId) {
    window.location.href = process.env.REACT_APP_LINK_URL || "/";
    return null;
  }

  return <Outlet />;
}
